/* eslint import/prefer-default-export:off */
export const shareChannels = ['Facebook', 'Twitter', 'Linkedin', 'email'];
export const bodyClass = 'cdm-blog-post-single';
export const bodyClassPrefix = 'cdm-blog-post-';
export const wpFootnoteClass = 'cdm-footnote-container';
